<echo-nx-calendar
  [days]="eventsService.days"
  panelClass="marlenka-calendar"
  [initialDay]="eventsService.selectedDate"
  (monthSelected)="monthSelected($event)"
  (dateSelected)="dateSelected($event)"
>
</echo-nx-calendar>
